
export const getProductImageFromStructure = (productStructure, productType, productModel) => {
  if (productModel === "ColorChecker 24 Patch Target") {
    return "/assets/products/photocameratargets-classic-toplevel-450.png";
  }

  if (productModel === "ColorChecker 140 Patch Target") {
    return "/assets/products/photocameratargets-digitalsg-calibrite-450.png";
  }

  const category = productStructure[productType];
  if (!category) return "/assets/products/default-device.png";

  // Flatten all products and subProducts
  const flattenProducts = (arr) =>
    arr.flatMap((item) =>
      item.subProducts ? flattenProducts(item.subProducts) : [item]
    );

  let products = category;
  if (products.some((p) => p.subProducts)) {
    products = flattenProducts(products);
  }

  // Try to match by name (productModel), fallback to first
  const match = products.find(
    (p) =>
      p.name?.toLowerCase() === productModel?.toLowerCase() ||
      p.id === productModel
  );
  return match?.thumb || match?.image || "/assets/products/default-device.png";
}; 